/**
 * COMPONENT: c-video (Tier 3 — Full Web Component)
 * Click-to-load video embed. Renders a cover image initially,
 * loads the iframe on first click for performance.
 *
 * Attributes:
 *   vid       — video ID (Vimeo)
 *   type      — video platform (currently Vimeo only)
 *   cover     — cover image URL
 *   pretitle  — text displayed above the title
 *   title     — video title
 *   length    — video duration label
 *
 * Usage:
 *   <c-video
 *     vid="123456789"
 *     cover="thumb.jpg"
 *     pretitle="Episode 1"
 *     title="Video Title"
 *     length="12:34">
 *   </c-video>
 */

class CVideo extends HTMLElement {

  constructor() {
    super();
    this.loaded = false;
  }

  connectedCallback() {
    const cover = this.getAttribute('cover') || null;
    const title = this.getAttribute('vtitle') || '';
    const autoplay = this.hasAttribute('autoplay') || false;

    let content = '';

    if (cover) {
      content += `
        <defer-image src="${cover}" type="background"></defer-image>
      `;
    }

    if (title) {
      content += `
        <h4 class="_title">${title}</h4>
      `;
    }

    this.innerHTML = content;

    if (autoplay) {
      setTimeout(() => {
        this._loadVideo(true)
      }, 1000);
    }

    this.addEventListener('click', () => this._loadVideo(), { once: true });
  }

  _loadVideo(muted) {
    const vid = this.getAttribute('vid');
    const cover = this.getAttribute('cover') || null;
    const aspect = this.getAttribute('aspect') || 'vertical';

    if (!vid || this.loaded) return;

    let content = this.innerHTML;
    this.innerHTML = content + `
      <div class="_embed -${aspect}">
        <mux-player
          playback-id="${vid}"
          poster="${cover}"
          autoplay
        ></mux-player>
      </div>
    `;

    if (muted) {
      this.querySelector('mux-player').muted = true;
    }

    setTimeout(() => {
      this.loaded = true;
      this.setAttribute('loaded', '');
    }, 750);
  }
}

window.customElements.define('c-video', CVideo);
